import { hotRanking, quickChannels, updateLog } from '@/mocks/home';

interface SidePanelProps {
  notify: (msg: string) => void;
}

export default function SidePanel({ notify }: SidePanelProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <div className="flex items-center justify-between">
          <h4 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <span className="flex h-5 w-5 items-center justify-center rounded-sm bg-primary-500 text-background-50">
              <i className="ri-bar-chart-box-line text-xs"></i>
            </span>
            资源更新热榜
          </h4>
          <button type="button" onClick={() => notify('已切换到完整榜单')} className="cursor-pointer text-xs text-foreground-500 transition-colors hover:text-primary-600">
            完整榜单
          </button>
        </div>
        <ol className="mt-3 flex flex-col divide-y divide-background-200">
          {hotRanking.map((item) => (
            <li key={item.rank}>
              <button
                type="button"
                onClick={() => notify(`正在打开：${item.title}`)}
                className="flex w-full cursor-pointer items-center gap-3 py-2.5 text-left"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                    item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm text-foreground-800">{item.title}</span>
                <span className="shrink-0 text-xs text-foreground-500">{item.heat}</span>
              </button>
            </li>
          ))}
        </ol>
      </div>

      <div className="rounded-xl border border-background-200 bg-background-100 p-5">
        <h4 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <span className="flex h-5 w-5 items-center justify-center rounded-sm bg-secondary-600 text-background-50">
            <i className="ri-apps-2-line text-xs"></i>
          </span>
          频道快捷入口
        </h4>
        <div className="mt-3 grid grid-cols-2 gap-2">
          {quickChannels.map((channel) => (
            <button
              key={channel.label}
              type="button"
              onClick={() => notify(`已进入「${channel.label}」`)}
              className="flex cursor-pointer items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-3 py-2.5 text-left transition-colors hover:border-primary-300"
            >
              <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md ${channel.color}`}>
                <i className={`${channel.icon} text-sm`}></i>
              </span>
              <span className="truncate text-xs text-foreground-800">{channel.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="rounded-xl border border-background-200 bg-background-50 p-5">
        <h4 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <span className="flex h-5 w-5 items-center justify-center rounded-sm bg-accent-500 text-foreground-950">
            <i className="ri-history-line text-xs"></i>
          </span>
          最近更新日志
        </h4>
        <ul className="mt-3 flex flex-col gap-3">
          {updateLog.map((log) => (
            <li key={`${log.date}-${log.title}`} className="flex gap-3">
              <span className="mt-0.5 shrink-0 rounded-sm bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600">{log.date}</span>
              <span className="min-w-0 flex-1 text-xs leading-relaxed text-foreground-700">
                <span className="mr-1.5 rounded-sm bg-accent-100 px-1.5 py-0.5 text-[10px] text-accent-900">{log.tag}</span>
                {log.title}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}